import { useState } from "react";
import { motion } from "framer-motion";

const images = ["/images/kaliateam2.png", "/images/img4.jpg", "/images/img3.jpg", "/images/img2.jpg", "/images/img7.jpg", "/images/img6.jpg", "/images/img1.jpg", "/images/kaliateam.png"];

const Galeri = () => {
  const [active, setActive] = useState<string | null>(null);

  return (
    <section className="bg-black text-white min-h-screen py-20 px-4 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* TITLE */}
        <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} className="text-center mb-12">
          <p className="uppercase tracking-[0.3em] text-pink-400 text-sm mb-3">GALERI</p>
          <h1 className="text-3xl md:text-5xl font-bold">Momen Kalia Siska</h1>
        </motion.div>

        {/* GRID BENTO */}
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[120px] md:auto-rows-[180px] gap-4">
          {images.map((img, i) => {
            // layout random biar gak monoton
            const layout = ["col-span-2 row-span-2", "col-span-1 row-span-1", "col-span-1 row-span-2", "col-span-2 row-span-1"];

            const style = layout[i % layout.length];

            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                viewport={{ once: true }}
                onClick={() => setActive(img)}
                className={`overflow-hidden rounded-2xl cursor-pointer ${style}`}>
                <img src={img} alt="" className="w-full h-full object-cover hover:scale-110 transition duration-500" />
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* ================= LIGHTBOX ================= */}
      {active && (
        <div onClick={() => setActive(null)} className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
          <motion.img src={active} initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="max-h-[90vh] rounded-2xl" />
        </div>
      )}
    </section>
  );
};

export default Galeri;
